import FromToProvider from "Providers/FromToProvider";

const withFromTo = (Comp: React.ComponentType<any>) => {
  return (props) => {
    return (
      <FromToProvider>
        <Comp {...(props as any)} />
      </FromToProvider>
    );
  };
};

export default withFromTo;
